import { collection, getDocs, onSnapshot } from 'firebase/firestore';

import { FSCollections } from '@src/constants/database';
import { db } from '@src/firebase/firebase';
import type { EmergencyAssignmentFirestoreRecord } from '@src/models/interfaces/emergency.interface';

import { toFirestoreRecord } from './emergencyRepository.utils';

export class EmergencyAssignmentRepository {
  subscribe(
    organizationId: string,
    incidentId: string,
    onData: (records: EmergencyAssignmentFirestoreRecord[]) => void,
    onError: (error: Error) => void,
  ): () => void {
    return onSnapshot(
      collection(
        db,
        FSCollections.ORGANIZATIONS,
        organizationId,
        FSCollections.EMERGENCIES,
        incidentId,
        FSCollections.EMERGENCY_ASSIGNMENTS,
      ),
      snapshot =>
        onData(
          snapshot.docs.map(document =>
            toFirestoreRecord<EmergencyAssignmentFirestoreRecord>(document),
          ),
        ),
      onError,
    );
  }

  async list(
    organizationId: string,
    incidentId: string,
  ): Promise<EmergencyAssignmentFirestoreRecord[]> {
    const snapshot = await getDocs(
      collection(
        db,
        FSCollections.ORGANIZATIONS,
        organizationId,
        FSCollections.EMERGENCIES,
        incidentId,
        FSCollections.EMERGENCY_ASSIGNMENTS,
      ),
    );
    return snapshot.docs.map(document =>
      toFirestoreRecord<EmergencyAssignmentFirestoreRecord>(document),
    );
  }
}
